"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE = exports.HOURS = exports.HOSTNAME = exports.FAX = exports.EMAIL = exports.ADDRESS = void 0;
var PHONE = '800.418.2551';
exports.PHONE = PHONE;
var FAX = '800.214.2956';
exports.FAX = FAX;
var EMAIL = 'info@my529.org';
exports.EMAIL = EMAIL;
var HOSTNAME = 'my529.org';
exports.HOSTNAME = HOSTNAME;
var HOURS = 'M-F, 7 a.m. to 5 p.m. MT';
exports.HOURS = HOURS;
var ADDRESS = 'PO BOX 145100\nSALT LAKE CITY, UT\n84114-5100';
exports.ADDRESS = ADDRESS;